import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { ColumnTitleProps, ColumnType } from 'antd/es/table/interface';
import * as React from 'react';
import styled from 'styled-components';
import { ColumnSortDirections } from './TableColumnSort';
import { getSortOrderFromTitleProps } from './TableDataHeaderSortCell';

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const TitleCol = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;
const IconCol = styled.div`
  flex: 0 0 auto;
  min-width: 0;
  margin-left: 4px;
  margin-right: -4px;
  color: ${props => props.theme.colorPrimary};
  font-size: 1.4em;
  margin-top: -1em;
  margin-bottom: -1em;
`;

export interface TableDataHeaderSortCellExperimentProps<T> {
  column?: ColumnType<T>;
  titleProps?: ColumnTitleProps<T>;
}
/**
 * Cella di Tabella (Header) per miglioratre la visualizzazione dell'ordinamento
 */
export function TableDataHeaderSortCellExperiment<T>(
  props: TableDataHeaderSortCellExperimentProps<T>,
) {
  const { column, titleProps } = props;
  if (!column || !titleProps) return null;

  const titleBefore = column.title as JSX.Element;

  const sortDirections = getSortOrderFromTitleProps(
    column,
    titleProps.sortColumns,
  );
  return (
    <TitleWrapper>
      <TitleCol>{titleBefore}</TitleCol>
      {sortDirections && (
        <IconCol>
          {sortDirections === ColumnSortDirections.ascend ? (
            <ArrowUpOutlined />
          ) : (
            <ArrowDownOutlined />
          )}
        </IconCol>
      )}
    </TitleWrapper>
  );
}
